import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { motion } from "framer-motion";
import Navbar from "./Navbar";
import Footer from "./Footer";
import ScrollProgress from "./fx/ScrollProgress";
import TechBackground from "./fx/TechBackground";
import CursorGlow from "./fx/CursorGlow";

export default function Layout() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [pathname]);

  return (
    <div className="site-dark relative min-h-screen flex flex-col bg-[#050B18] text-white">
      <TechBackground dark fixed density={50} className="z-0 opacity-60" />
      <CursorGlow />
      <ScrollProgress />
      <Navbar />
      <motion.main
        key={pathname}
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
        className="relative z-[2] flex-1"
        data-testid="page-main"
      >
        <Outlet />
      </motion.main>
      <div className="relative z-[2]">
        <Footer />
      </div>
    </div>
  );
}
